// Pure helpers for the pricing screens.

export type PlanLike = { price_cents: number; currency: string; interval: 'month' | 'year' }

/**
 * How many months a yearly plan gives away against paying monthly, rounded
 * to whole months — "2 months free" for €790/year next to €79/month. Null
 * when there is no monthly plan in the same currency to compare with, or
 * the yearly plan is not actually cheaper.
 */
export function monthsFree(yearly: PlanLike, plans: readonly PlanLike[]): number | null {
  if (yearly.interval !== 'year') return null
  const monthly = plans.find((p) => p.interval === 'month' && p.currency === yearly.currency)
  if (!monthly || monthly.price_cents <= 0) return null
  const months = Math.round((12 * monthly.price_cents - yearly.price_cents) / monthly.price_cents)
  return months > 0 ? months : null
}

/** What a yearly plan costs per month, for "about €65.83 per month". */
export function perMonthCents(plan: PlanLike): number {
  return plan.interval === 'year' ? Math.round(plan.price_cents / 12) : plan.price_cents
}

/**
 * The plan the picker opens on: the yearly one when there is one (it is the
 * better deal and the one we want chosen), else the first by sort order.
 */
export function defaultPlan<T extends PlanLike>(plans: readonly T[]): T | undefined {
  return plans.find((p) => p.interval === 'year') ?? plans[0]
}
